const CLIENT_ID: string = import.meta.env.VITE_CLIENT_ID || '{clientId}';
const ISSUER: string = import.meta.env.VITE_ISSUER || 'https://{yourOktaDomain}.com/oauth2/default';
const BASENAME: string = import.meta.env.VITE_BASE_URL || '/';
// BASENAME includes trailing slash
const REDIRECT_URI: string = `${window.location.origin}${BASENAME}login/callback`;

export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: false,
  },
  app: {
    basename: BASENAME,
  },
};
